export default __webpack_public_path__ + "new-volunteer-icon-dark.svg";